import { Stack } from '@mui/material';
import LmTextField from '../../../../components/common/LmTextField';
import VegaFormInputField from '../../../../components/common/VegaFormInputField';
import {
  getConfigurationState,
  setConfigurations,
} from '../../../../features/configurationSlice';
import { useAppDispatch, useAppSelector } from '../../../../store';
import {
  ConfigValueProps,
  ConfigurationDto,
} from '../../../../types/configurationType';

const RouteDeviationForm = () => {
  const { configurations } = useAppSelector(getConfigurationState);
  const dispatch = useAppDispatch();

  const handleConfigChange = (key: keyof ConfigurationDto, value: any) => {
    const updateConfig = { ...configurations, [key]: value };
    dispatch(setConfigurations(updateConfig));
  };

  const handleRouteDeviationChange = (
    key: keyof ConfigValueProps,
    value: number | string
  ) => {
    const updateConfigValueObj = { ...configurations.config, [key]: value };
    handleConfigChange('config', updateConfigValueObj);
  };

  return (
    <Stack gap={2}>
      <VegaFormInputField label={'Deviation Count'}>
        <LmTextField
          type="number"
          value={configurations.config?.routeDeviationCount ?? 0}
          onChange={e => {
            const value = e.target.value && parseFloat(e.target.value);
            handleRouteDeviationChange('routeDeviationCount', value);
          }}
        />
      </VegaFormInputField>
      <VegaFormInputField label={'Branch Reason Deadline'}>
        <LmTextField
          type="number"
          value={configurations.config?.breachReasonDeadline ?? 0}
          onChange={e => {
            const value = e.target.value && parseFloat(e.target.value);
            handleRouteDeviationChange('breachReasonDeadline', value);
          }}
        />
      </VegaFormInputField>
      <VegaFormInputField label={'Next level escalation deadline'}>
        <LmTextField
          type="number"
          value={configurations.config?.escalationDeadline ?? 0}
          onChange={e => {
            const value = e.target.value && parseFloat(e.target.value);
            handleRouteDeviationChange('escalationDeadline', value);
          }}
        />
      </VegaFormInputField>
    </Stack>
  );
};

export default RouteDeviationForm;
